import { ca } from '@cian/analytics';

import { BASE_EVENT } from '../../tracking';
import { EPageType } from '../../types/analytics/sopr1';

export const trackFatFeatureClick = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'click_benefits',
    page: {
      pageType: EPageType.CardKP,
    },
  });
};
